import {Component, OnInit, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

@Component({
  selector: 'app-google-maps',
  templateUrl: './gmaps.component.html',
  styleUrls: ['./gmaps.component.less']
})

export class MapsComponent implements OnInit {
  @Input() latitude: number;
  @Input() longitude: number;
  @Output() selectedChange = new EventEmitter();

  showOptions = false;

  constructor() {
  }
  ngOnInit() {
  }
  selectOption() {
    this.selectedChange.emit();
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/g-maps/gmaps.component.ts